import { Button, Input, Space, Typography, message } from "antd"
import { doc, updateDoc } from "firebase/firestore"
import React, { useState } from "react"
import { db } from "../../../firebase/config"
import { CheckCircleOutlined, CloseCircleOutlined, EditOutlined } from "@ant-design/icons"

const { Text, Link } = Typography

export default function EditEntry({ text, data }) {
  const [editing, setEditing] = useState(false)
  const [localText, setLocalText] = useState(text)

  //handle update doc
  async function updateProductName() {
    const documentRef = doc(db, "priceCalculation", data.id)
    try {
      await updateDoc(documentRef, {
        "product.productName": localText,
      })
      message.success("Updated!")
      setEditing(!editing)
      console.log("updated")
    } catch (error) {
      message.error("error happened", error)
      console.log(error)
      handleStopEditing()
    }
  }

  //handle start editing
  const handleStartEditing = () => {
    setEditing(!editing)
  }
  //handle stop  editing
  const handleStopEditing = () => {
    setEditing(!editing)
    setLocalText(text)
    message.warning("cancelled")
  }

  //handle input change for local text
  const handleInputChange = (value) => {
    setLocalText(value)
  }

  //handle accept values
  const handleDoneEditing = () => {
    updateProductName()
  }

  if (!editing) {
    return (
      <>
        <Space>
          <Text>{localText}</Text>
          <Link onClick={handleStartEditing}>
            <EditOutlined />
          </Link>
        </Space>
      </>
    )
  } else {
    return (
      <>
        <Space.Compact>
          <Input
            size="small"
            onChange={(event) => handleInputChange(event.target.value)}
            value={localText}
          />
          <Button style={{ background: "#52c41a" }} size="small">
            <CheckCircleOutlined onClick={handleDoneEditing} style={{ color: "white" }} />
          </Button>
          <Button type="primary" danger size="small" onClick={handleStopEditing}>
            <CloseCircleOutlined />
          </Button>
        </Space.Compact>
      </>
    )
  }
}
